import React from 'react';

import Layout from '../components/layout';
import SEO from '../components/seo';
// import chumenLogo from '../images/chumen-logo-svg.svg';
function ContactPage() {
  return (
    <Layout>
      <SEO
        keywords={[`gatsby`, `tailwind`, `react`, `tailwindcss`]}
        title='Contact'
      />
      <section className='bg-white p-10'>
        <p className='mt-4'>
          <b>CONTACT US</b>
          <br />
          If you have questions or comments about this Privacy Policy, please
          contact us at:
        </p>
        <pre className='mt-2'>
          <br />
          Address: CHU MEN CO. LTD No. 146, Futan Road, Tanzi District Taichung
          City, Taiwan
          <br />
          Telephone No. 04-25363121
          <br />
          Email: <a href='mailto:chumendev@gmail.com'>chumendev@gmail.com</a>
        </pre>
      </section>
    </Layout>
  );
}

export default ContactPage;
